// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import Vuetify from 'vuetify'
import vuetify from '@/plugins/vuetify'
import Vuex from 'vuex'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { Button, Select } from 'element-ui';
import Element from 'element-ui';
// 引入vue-UUID组件
import UUID from 'vue-uuid'
import https from './https'
import { SlickList, SlickItem } from 'vue-slicksort'
Vue.prototype.https=https
Vue.use(UUID)


Vue.use(Element, { size: 'small', zIndex: 3000 });

Vue.use(Vuex)
Vue.use(Vuetify)
Vue.use(VXETable)
Vue.use(ElementUI);
Vue.component(Button.name, Button);
Vue.component(Select.name, Select);



Vue.prototype.$http = axios

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  vuetify,
  el: '#app',
  router,
  components: { App ,
    SlickList,
    SlickItem },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js